export class TOASTR {
  public static readonly TYPE = {
    SUCCESS: 'success',
    ERROR: 'error',
    WARNING: 'warning',
    INFO: 'info',
  };
  public static readonly ICONS = {
    SUCCESS: 'fas fa-check-circle',
    ERROR: 'fas fa-times-circle',
    WARNING: 'fas fa-exclamation-circle',
    INFO: 'fas fa-info-circle',
  };
  public static readonly POSITION = 'toast-top-center';
  public static readonly ANIMATION = 'ease-in-out';
  public static readonly TIMEOUT = 4000;
  public static readonly DELAY = 150;
}
